
window.activateActivitiesFilter = activateActivitiesFilter;
window.activateMediaFilter = activateMediaFilter;

let selectedCategory;
let selectedBirthyear;
let selectedType;
let selectedHoliday;
let selectedLocation;
let searchQuery;
let selectedYear;
let lazyLoadFirst;
let lazyLoadSecond;


function activateActivitiesFilter() {
    "use strict";

    lazyLoadFirst = new LazyLoad({
        elements_selector: ".lazy-first",
        threshold: 300,
    });

    lazyLoadSecond = new LazyLoad({
        elements_selector: ".lazy-second",
        threshold: -100,
    });

    selectedCategory = getUrlParameter('categorie');
    selectedBirthyear = getUrlParameter('geboortejaar');
    selectedType = getUrlParameter('soort');
    selectedHoliday = getUrlParameter('holiday_period');
    selectedLocation = getUrlParameter('location');
    searchQuery = getUrlParameter('q');

    const birthyearSelector = $('#age');
    const categorySelector = $('#category');
    const typeSelector = $('#type');
    const holidaySelector = $('#holiday_period');
    const locationSelector = $('#location');
    const searchInput = $('#filter-search-input');

    categorySelector.val(selectedCategory);
    birthyearSelector.val(selectedBirthyear);
    typeSelector.val(selectedType);
    holidaySelector.val(selectedHoliday.split(','));
    locationSelector.val(selectedLocation.split(','));
    searchInput.val(searchQuery);

    categorySelector.change(function (e) {
        selectedCategory = $(this).val();
        updateQueryStringParam('categorie', selectedCategory);
        fetchResults();
    });

    birthyearSelector.change(function (e) {
        selectedBirthyear = $(this).val();
        updateQueryStringParam('geboortejaar', selectedBirthyear);
        fetchResults();
    });

    typeSelector.change(function (e) {
        selectedType = $(this).val();
        updateQueryStringParam('soort', selectedType);
        fetchResults();
    });

    holidaySelector.change(function (e) {
        selectedHoliday = $(this).val().join(',');
        updateQueryStringParam('holiday_period', selectedHoliday);
        fetchResults();
    });

    locationSelector.change(function (e) {
        selectedLocation = $(this).val().join(',');
        updateQueryStringParam('location', selectedLocation);
        fetchResults();
    });

    searchInput.keypress(function (e) {
        const key = e.which;
        if (key === 13) {
            searchQuery = $(this).val();
            updateQueryStringParam('q', searchQuery);
            fetchResults();
        }
    });

    $('.filter--open button').on('click', function (e) {
        searchQuery = searchInput.val();
        updateQueryStringParam('q', searchQuery);
        fetchResults();
    });
}

function activateMediaFilter() {
    "use strict";

    selectedCategory = getUrlParameter('categorie');
    selectedYear = getUrlParameter('jaar');
    selectedType = getUrlParameter('soort');
    searchQuery = getUrlParameter('q');

    const yearSelector = $('#year');
    const categorySelector = $('#category');
    const typeSelector = $('.filter-type');
    const searchInput = $('#filter-search-input');

    categorySelector.val(selectedCategory);
    typeSelector.filter('[value="' + selectedType + '"]').prop('checked', true);
    yearSelector.val(selectedYear);
    searchInput.val(searchQuery);

    categorySelector.change(function (e) {
        selectedCategory = $(this).val();
        updateQueryStringParam('categorie', selectedCategory);
        location.reload();
    });

    yearSelector.change(function (e) {
        selectedYear = $(this).val();
        updateQueryStringParam('jaar', selectedYear);
        location.reload();
    });

    typeSelector.change(function (e) {
        selectedType = $(this).val();
        updateQueryStringParam('soort', selectedType);
        location.reload();
    });

    searchInput.keypress(function (e) {
        const key = e.which;
        if (key === 13) {
            searchQuery = $(this).val();
            updateQueryStringParam('q', searchQuery);
            location.reload();
        }
    });

}

function fetchResults() {
    "use strict";
    //$('#results').empty().append('<h2>Laden...</h2>');

    $('#results').addClass('loading');
    let headers = new Headers();
    // TODO delete me before going live
    headers.append('Authorization', 'Basic YW50d2VycGZhY3Rvcnk6UGxheVNwb3J0MQ==');

    fetch('/api/filter?' + $.param({
        categorie: selectedCategory,
        geboortejaar: selectedBirthyear,
        soort: selectedType,
        holiday_period: selectedHoliday,
        location: selectedLocation,
        q: searchQuery
    }), {
        method: 'GET',
        headers: headers,
    })
        .then(function (response) {
            return response.json();
        }).then(function (body) {
        $('#results').empty().append(body.html).removeClass('loading');
        $('#filtered_words').empty().append(body.filtered_words);
        $('.filter--result--content .list--logo_icon').matchHeight();
        $('.filter--result--content .filter--result--name').matchHeight();
        lazyLoadFirst.update();
        lazyLoadSecond.update();
    });
}


function getUrlParameter(name) {
    "use strict";
    name = name.replace(/[[\]]/g, '\\$&');
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(name);
    return paramValue === null ? '' : decodeURIComponent(paramValue.replace(/\+/g, ' '));
}

function updateQueryStringParam(key, value) {
    if (!key || typeof key !== 'string') {
        throw new Error('Key must be a string');
    }

    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (value === undefined || value === null || value === '') {
        params.delete(key);
    } else {
        params.set(key, (value));
    }

    history.pushState(null, '', url.href);
}

$('.select2').select2({
    theme: "classic"
});
